export default __webpack_public_path__ + "static/media/22185147573711bc8652b9d4a565bc39.svg";